import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const EditEscrowFieldsEvent = BaseLoanEvent.extend({
  type: z.literal('editEscrowFields'),
  escrowBalance: z.number().optional(),
  monthlyEscrowPayment: z.number().optional(),
  /**
   * @deprecated
   * Use mortgage insurance escrow setting instead
   */
  monthlyMortgageInsurancePayment: z.number().optional(),
  paymentDueId: PaymentDueId,
  sendEmail: z.boolean(),
});
export type EditEscrowFieldsEvent = z.infer<typeof EditEscrowFieldsEvent>;
